function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-grow: 1;\n    color: inherit;\n    ",
        "\n    padding: ",
        " ",
        ";\n    height: ",
        ";\n\n    &::placeholder {\n        color: ",
        ";\n    }\n\n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n                  @media (hover: hover) {\n                      &:hover {\n                          background-color: ",
        ";\n                      }\n                  }\n              "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                  box-shadow: 0 0 0 1px\n                      ",
        ";\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    box-sizing: border-box;\n    display: flex;\n    flex: 1;\n    align-items: center;\n    color: ",
        ";\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    transition: color 50ms ease, background-color 50ms ease, box-shadow 50ms ease;\n    position: relative;\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    gap: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { rem } from "polished";
import React, { forwardRef, useState } from "react";
import styled, { css } from "styled-components";
import { semanticColor } from "../palette/semantic";
import { globalBodyPrimary } from "../typography";
import { useId } from "@reach/auto-id";
import { ErrorMessage, FloatingLabel, getExpandedFieldStyles } from "./TextInput";
import { useRef } from "react";
import { useEffect } from "react";
var Textarea = /*#__PURE__*/ forwardRef(function(props, ref) {
    var label = props.label, className = props.className, error = props.error, floatingLabel = props.floatingLabel, fitContent = props.fitContent, id = props.id, textareaProps = _objectWithoutProperties(props, [
        "label",
        "className",
        "error",
        "floatingLabel",
        "fitContent",
        "id"
    ]);
    // Manually manage focus states as a workaround for `:focus-within`. `TextareaWrapper` should
    // have an outline when the text input is focused, but not the adornment buttons. Using
    // `:focus-within` will display the outline when either the text input or adornment receive
    // focus.
    var _$ref5 = useState(false), focused = _$ref5[0], setFocused = _$ref5[1];
    var _$ref1 = useState("auto"), height = _$ref1[0], setHeight = _$ref1[1];
    var _$ref2 = useState(function() {
        return !!props.value;
    }), hasText = _$ref2[0], setHasText = _$ref2[1];
    // TODO replace with useId exported from react 18
    var textareaId = useId(id);
    var errorId = useId();
    var wrapperRef = useRef(null);
    var shouldExpandTextarea = focused || hasText;
    useEffect(function() {
        if (fitContent && props.value) {
            var _$ref, _$ref3;
            var _$ref4;
            setHeight((_$ref4 = (_$ref3 = (_$ref = wrapperRef.current) === null || _$ref === void 0 ? void 0 : _$ref.querySelector("textarea")) === null || _$ref3 === void 0 ? void 0 : _$ref3.scrollHeight) !== null && _$ref4 !== void 0 ? _$ref4 : "auto");
        }
    }, [
        props.value,
        fitContent
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        className: className,
        children: [
            /*#__PURE__*/ _jsxs(TextareaWrapper, {
                ref: wrapperRef,
                focused: focused,
                error: Boolean(error),
                children: [
                    floatingLabel && /*#__PURE__*/ _jsx(FloatingLabel, {
                        // TODO replace when useId is updated
                        htmlFor: textareaId !== null && textareaId !== void 0 ? textareaId : "",
                        floating: shouldExpandTextarea,
                        error: error,
                        label: props.label,
                        charCount: typeof props.value === "string" ? props.value.length : undefined,
                        maxLength: props.maxLength
                    }),
                    /*#__PURE__*/ _jsx(StyledTextArea, _objectSpread({}, textareaProps, {
                        height: typeof height === "string" ? height : rem(height),
                        id: textareaId,
                        ref: ref,
                        expanded: floatingLabel ? shouldExpandTextarea : undefined,
                        error: Boolean(error),
                        "aria-describedby": props["aria-describedby"],
                        autoComplete: "off",
                        placeholder: floatingLabel ? undefined : props.placeholder || props.label,
                        "aria-label": floatingLabel ? undefined : props.label,
                        onChange: function(e) {
                            var _$ref;
                            setHasText(!!e.target.value);
                            (_$ref = props.onChange) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
                        },
                        onFocus: function(e) {
                            var _$ref;
                            setFocused(true);
                            (_$ref = props.onFocus) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
                        },
                        onBlur: function(e) {
                            var _$ref;
                            setFocused(false);
                            (_$ref = props.onBlur) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
                        }
                    }))
                ]
            }),
            error && /*#__PURE__*/ _jsx(ErrorMessage, {
                id: errorId,
                children: error
            })
        ]
    });
});
export { Textarea };
var StyledTextArea = styled.textarea.withConfig({
    componentId: "sc-99061901-0"
})(_templateObject(), globalBodyPrimary, rem(12), rem(16), function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var error = param.error;
    return semanticColor("editable-primary-placeholder".concat(error ? "--error" : ""));
}, function(param) {
    var expanded = param.expanded;
    return getExpandedFieldStyles(expanded);
});
var TextareaWrapper = styled.div.withConfig({
    componentId: "sc-99061901-1"
})(_templateObject3(), function(param) {
    var error = param.error;
    return semanticColor("editable-primary-fg".concat(error ? "--error" : ""));
}, function(param) {
    var error = param.error;
    return semanticColor("editable-primary-bg".concat(error ? "--error" : ""));
}, rem(12), function(param) {
    var error = param.error;
    return !error ? css(_templateObject1(), semanticColor("editable-primary-bg--hover")) : null;
}, function(param) {
    var focused = param.focused, error = param.error;
    return focused ? css(_templateObject2(), semanticColor("editable-primary-border".concat(error ? "--error" : "", "--focused"))) : null;
});
var Container = styled.div.withConfig({
    componentId: "sc-99061901-2"
})(_templateObject4(), rem(8));
